import React from 'react';

const BrandingFooter = () => {
  return (
    <div className="fixed bottom-4 right-4 z-50 flex items-center gap-2 opacity-70 hover:opacity-100 transition-opacity duration-300 group">
      {/* Vertical line separator */}
      <div className="h-4 w-[2px] bg-[#888888] group-hover:bg-[#444444] transition-colors duration-300"></div>
      
      {/* Branding text */}
      <span className="text-xs font-sans text-[#888888] group-hover:text-[#444444] transition-colors duration-300 whitespace-nowrap">
        LetOps by J.S Software
      </span>
    </div>
  );
};

export default BrandingFooter;